/**
 * How a company's or a client group's name is written down.
 *
 * Both are printed in upper case — on screen, in every workbook and PDF, and in
 * the QuickBooks customer column — because they are the two names that travel
 * between this system, the register, the accountant's file and the client's own
 * letterhead, and the four disagreed about capitals. "Astride US Inc.",
 * "ASTRIDE US INC." and "astride us inc" were three spellings of one client, and
 * the only way to stop a fourth appearing was to stop storing the difference.
 *
 * So this is applied on the write path rather than at each render: the register
 * holds the upper-case spelling, and the denormalised copies — a contact's
 * `company_name`, a company's `client_group_name`, an invoice line's
 * `company_name` — are taken from it and are upper case for free. Matching is
 * unaffected, because every lookup in the importers and the pickers already
 * compares case-insensitively.
 *
 * `null` comes back for a blank, so an optional name reads as "not set" rather
 * than as an empty string the templates would print as a line of nothing.
 */
export function upperEntityName(value: string | null | undefined): string | null {
  if (value === null || value === undefined) return null;
  const trimmed = value.trim().replace(/\s+/g, " ");
  return trimmed ? trimmed.toUpperCase() : null;
}
